import { render, staticRenderFns } from "./ApplicationInfo.vue?vue&type=template&id=85646c46&"
import script from "./ApplicationInfo.vue?vue&type=script&lang=js&"
export * from "./ApplicationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports